import legsReducer from "./legsSlice";
import legReducer from "./legSlice";

const legs = {
  legs: legsReducer,
  leg: legReducer,
};

export default legs;
